import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciSwitchComponent } from './luci-switch.component';
import {FormsModule} from '@angular/forms';



@NgModule({
  declarations: [LuciSwitchComponent],
  exports: [LuciSwitchComponent],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class LuciSwitchModule { }
